import { createAction } from '@reduxjs/toolkit';

const login = createAction('login/succeeded');
const logout = createAction('logout/succeeded');
const setProfile = createAction('profile/setProfile');

export { login, logout, setProfile };
